export interface Venda {
  id?: string
  data: string
  vendedor: string
  canal: string
  valor: number
  valor_caixa: number | null
  marca: string
  cidade: string
  produto: string
  pagou: 0 | 1
  follow_up?: string | null
}

export const mockVendas: Venda[] = [
  {
    id: '1',
    data: '2026-05-12',
    vendedor: 'Pedro',
    canal: 'Tráfego Pago',
    valor: 2500,
    valor_caixa: 2500,
    marca: 'Vision',
    cidade: 'Fortaleza',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '2',
    data: '2026-05-15',
    vendedor: 'Gabriel',
    canal: 'WhatsApp',
    valor: 1900,
    valor_caixa: 1900,
    marca: 'Kona',
    cidade: 'Caucaia',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '3',
    data: '2026-05-18',
    vendedor: 'Felipe',
    canal: 'WhatsApp',
    valor: 1200,
    valor_caixa: 1200,
    marca: 'Dropshot',
    cidade: 'Fortaleza',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '4',
    data: '2026-05-20',
    vendedor: 'Arthur',
    canal: 'Tráfego Pago',
    valor: 750,
    valor_caixa: 750,
    marca: 'Heroes',
    cidade: 'Maracanaú',
    produto: 'Bolsa',
    pagou: 1,
    follow_up: null
  },
  {
    id: '5',
    data: '2026-05-22',
    vendedor: 'Targino',
    canal: 'Indicação',
    valor: 3200,
    valor_caixa: null,
    marca: 'Zand',
    cidade: 'Aquiraz',
    produto: 'Raquete',
    pagou: 0,
    follow_up: 'Cobrar'
  },
  {
    id: '6',
    data: '2026-05-25',
    vendedor: 'João',
    canal: 'Orgânico',
    valor: 2800,
    valor_caixa: 2800,
    marca: 'Vision',
    cidade: 'Fortaleza',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '7',
    data: '2026-05-27',
    vendedor: 'Pedro',
    canal: 'WhatsApp',
    valor: 1500,
    valor_caixa: 1500,
    marca: 'Kona',
    cidade: 'Caucaia',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '8',
    data: '2026-05-28',
    vendedor: 'Gabriel',
    canal: 'Tráfego Pago',
    valor: 2100,
    valor_caixa: 2100,
    marca: 'Drop',
    cidade: 'Fortaleza',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '9',
    data: '2026-05-30',
    vendedor: 'Felipe',
    canal: 'Indicação',
    valor: 1800,
    valor_caixa: 1800,
    marca: 'Zand',
    cidade: 'Maracanaú',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '10',
    data: '2026-06-01',
    vendedor: 'Arthur',
    canal: 'WhatsApp',
    valor: 950,
    valor_caixa: 950,
    marca: 'Vision',
    cidade: 'Fortaleza',
    produto: 'Vestuário',
    pagou: 1,
    follow_up: null
  },
  {
    id: '11',
    data: '2026-06-03',
    vendedor: 'Targino',
    canal: 'Tráfego Pago',
    valor: 2650,
    valor_caixa: 2650,
    marca: 'Heroes',
    cidade: 'Aquiraz',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '12',
    data: '2026-06-05',
    vendedor: 'João',
    canal: 'WhatsApp',
    valor: 1700,
    valor_caixa: 1700,
    marca: 'Kona',
    cidade: 'Caucaia',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '13',
    data: '2026-06-07',
    vendedor: 'Pedro',
    canal: 'Orgânico',
    valor: 3100,
    valor_caixa: 3100,
    marca: 'Drop',
    cidade: 'Fortaleza',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  },
  {
    id: '14',
    data: '2026-06-08',
    vendedor: 'Gabriel',
    canal: 'Indicação',
    valor: 2400,
    valor_caixa: null,
    marca: 'Zand',
    cidade: 'Maracanaú',
    produto: 'Raquete',
    pagou: 0,
    follow_up: 'Aguardando pagamento'
  },
  {
    id: '15',
    data: '2026-06-09',
    vendedor: 'Felipe',
    canal: 'Tráfego Pago',
    valor: 2750,
    valor_caixa: 2750,
    marca: 'Vision',
    cidade: 'Aquiraz',
    produto: 'Raquete',
    pagou: 1,
    follow_up: null
  }
];

export const mockKPIResumo = {
  faturamento_total: 34800,
  valor_caixa_total: 31350,
  gap: 3450,
  gap_pct: 9.91,
  num_vendas: 15,
  num_vendedores: 6,
  ticket_medio: 2320,
  inadimplencia: 2,
  taxa_recebimento: 86.67
};
